<div id="crop-health-map-header">
  <p class="title">
    <span class="">{{ 'doktar_app.services.crop_monitoring.crop_health' | translate }}</span>
    @if (selectedDay) {
      <span class="source">
        {{ 'doktar_app.common.source' | translate }}: {{ selectedDay.sourceType === 0 ? 'Sentinel' : 'Planet' }}
      </span>
    }
  </p>
  <div class="d-flex gap-1">
    @if (!loading && cropHealthData?.mapList?.length > 0) {
      <span
        class="note-btn"
        [class.active]="cropHealthService.showNotePins$ | async"
        [class.disabled]="selectedDay?.isCloudly"
        (click)="activateNote()">
        @if (cropHealthService.showNotePins$ | async) {
          <i class="ph-fill ph-note"></i>
        } @else {
          <i class="ph-bold ph-note"></i>
        }
      </span>
    }
    <span class="fullscreen-btn" (click)="clickFullScreenEvent.emit()">
      @if (fullScreenMode) {
        <span>{{ 'doktar_app.common.exit_full_screen' | translate }}</span>
        <i class="ph-bold ph-x"></i>
      } @else {
        <span>{{ 'doktar_app.common.full_screen' | translate }}</span>
      }
    </span>
  </div>
</div>
